import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'dss-libs-ui-modal-list-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './modal-list-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalListSkeletonComponent {
  readonly rows = input<number>(4);
  readonly showTrailing = input<boolean>(true);

  readonly rowsArray = computed(() => Array.from({ length: this.rows() }, (_, i) => i + 1));
}
